module.exports = __webpack_public_path__ + "img/management.24fe4bcf.svg";